import React from 'react';
import Input from '@material-ui/core/Input';
import InputLabel from '@material-ui/core/InputLabel';
import MenuItem from '@material-ui/core/MenuItem';
import FormHelperText from '@material-ui/core/FormHelperText';
import FormLabel from '@material-ui/core/FormLabel';
import FormControl from '@material-ui/core/FormControl';
import FormGroup from '@material-ui/core/FormGroup';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import RadioGroup from '@material-ui/core/RadioGroup';
import Radio from '@material-ui/core/Radio';
import Switch from '@material-ui/core/Switch';
import Select from '@material-ui/core/Select';
import Paper from '@material-ui/core/Paper';
import LinearProgress from '@material-ui/core/LinearProgress';
import InputAdornment from '@material-ui/core/InputAdornment';
import Button from '@material-ui/core/Button';
import Typography from '@material-ui/core/Typography';
import EditIcon from '@material-ui/icons/Edit';
import IconButton from '@material-ui/core/IconButton';
import Tooltip from '@material-ui/core/Tooltip';
import TextField from '@material-ui/core/TextField';
import Chip from '@material-ui/core/Chip';
import Avatar from '@material-ui/core/Avatar';
import { mascaraCelular9Digito, formataDataDDMMYYYYParaHTML5, formataDataHTML5ParaDDMMYYYY } from '../../modules/util';
import CONSTANTS from '../../constants';

import FormPessoaContainer from '../../containers/fiadores/form-pessoa';
import Tabs from '@material-ui/core/Tabs';
import Tab from '@material-ui/core/Tab';

import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';

import FileUpload from '../file-upload';




/*
CEP  do  resp e fiador deve carregar endereco too

 informe cpf  do Fiador 1
 carrega dados dele no form
 caso tenha conjuge mesma coisa informe CPF + carrega dados

informe cpf  do Fiador 2
 carrega dados dele no form
 caso tenha conjuge mesma coisa informe CPF + carrega dados

 OBS:  o responsavel  tb  é mesma regra 

 FAZER algo generico
*/
export default class FormFiador extends React.Component {
    state = {
        abaFiador: 0,
        openDialog: false,
        msgConfirmacao: ''
    };
    componentDidMount() {

    }
    handleCloseDialog(open, msgConfirmacao, acaoOK) {
        console.log('handleCloseDialog');
        if (open) {
            this.acaoOK = acaoOK;
        }
        this.setState({
            msgConfirmacao: msgConfirmacao,
            openDialog: open
        });

    }
    setAba(event, value) {
        this.setState({
            abaFiador: value
        });
    }
    render() {
        let dialogo = (
            <Dialog
                open={this.state.openDialog}
                onClose={() => this.handleCloseDialog(false)}
                aria-labelledby="form-dialog-title"
            >
                <DialogTitle id="form-dialog-title"> CONFIRMAÇÃO </DialogTitle>
                <DialogContent>
                    <DialogContentText>
                        {this.state.msgConfirmacao}
                    </DialogContentText>
                </DialogContent>
                <DialogActions>
                    <Button onClick={() => this.handleCloseDialog(false)} color="primary">
                        Cancelar
                </Button>
                    <Button onClick={() => {
                        this.acaoOK();
                        this.handleCloseDialog(false);

                    }} color="primary">
                        OK
                </Button>
                </DialogActions>
            </Dialog>
        );


        let btnAddFiador = (
            <Button
                style={{
                    marginRight: '15px'
                }}
                onClick={this.props.onAddFiador} variant="raised" color="primary" >
                Informar mais 1 Fiador
            </Button>
        );
        if (this.props.listFiadores.length >= 2) {
            btnAddFiador = null;
        }
        console.log('render fiador');
        return (
            <div>
                {/* <Tabs
                    value={this.state.abaFiador}
                    indicatorColor="primary"
                    textColor="primary"
                    onChange={this.setAba.bind(this)}
                    centered
                >
                    {this.props.listFiadores.map((item, indice) => {
                        return (
                            <Tab label={'Fiador ' + (indice +1)} />
                        );
                    })}
                </Tabs> */
                }


                {this.props.listFiadores.map((item, indice) => {
                    // if (indice !== this.state.abaFiador) {
                    //     return null;
                    // }
                    console.log('fiador', indice);
                    let btnRemover = null;
                    if (!item.bloquearTudo && this.props.listFiadores.length > 1) { // 
                        btnRemover = (
                            <div style={{ position: 'absolute', top: 27, right: 10, textAlign: 'right' }}>
                                <Button
                                    onClick={() => this.handleCloseDialog(true, "Deseja remover este fiador?", () => { this.props.onRemoveFiador(indice) })}
                                    variant="raised" style={{ backgroundColor: 'red', color: '#fff' }} >
                                    Remover este Fiador
                                </Button>
                            </div>
                        );
                    }
                    
                    return (
                        <FormPessoaContainer
                            btnRemover={btnRemover}
                            key={indice}
                            indiceFiador={indice}
                            formTitulo={'Dados do Fiador ' + (indice + 1)}
                            tipoPessoa={CONSTANTS._TIPO_PESSOA.FIADOR}
                            {...item}
                        />
                    );
                })}
                <div style={{ padding: '20px', backgroundColor: '#eee', textAlign: 'right', display: btnAddFiador ? 'block' : 'none' }}>
                    {btnAddFiador}
                </div>
                <FileUpload
                    origem="F"
                    listArquivos={this.props.listArquivos}
                    onSaveFile={this.props.onSaveFile}
                    onDeleteFile={this.props.removeItemArquivoFiador}
                />


                <div style={{ padding: '20px', backgroundColor: '#eee', textAlign: 'right', marginTop: '80px' }}>


                    <Button
                        disabled={this.props.concluindo}
                        onClick={() => {
                            this.handleCloseDialog(true, "Deseja concluir o envio dos Fiadores?", this.props.onConcluirEnvioFiadores);
                        }}
                        variant="raised" color="primary"
                    >
                        Concluir Envio de Fiadores
                     </Button>
                </div>
            
                <div style={{padding: '20px'}}>
                    {this.props.concluindo && this.props.progressoFinalizarFiador}
                </div>
                {this.props.concluindo ? <LinearProgress /> : null}


                {dialogo}

            </div >
        );
    }
}


// WEBPACK FOOTER //
// ./src/components/fiadores/form-fiador.js